export class WebhookV1BackupJobSkippedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        },
        {
            "name": "userMessage",
            "baseName": "userMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "details",
            "baseName": "details",
            "type": "WebhookV1BackupJobDetails",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1BackupJobSkippedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
